import request from '@/utils/request'

const urlApi = {
  list: '/index/login/menu/getList'
}

/**
 * 获取菜单列表
 * @returns {*}
 */
export function menuList () {
  return request({
    url: urlApi.list,
    method: 'get'
  })
}
